<template>
  <v-app>
    <div v-if="isAutenticated">
    <sidenav
      color="warning"
      custom_class="warning"
      class="fixed-start"
    />
    <main
      class="main-content position-relative max-height-vh-100 h-100"
    >
      <!-- nav -->
      <navbar
        color="opacity-8"
        :min-nav="navbarMinimize"
      />
      <div class="Cargando">
        <div v-if="this.$store.state.Cargando" :class="['modal_cargando', { 'show': this.$store.state.Cargando }]"
             @transitionend="onTransitionEnd">
          <div class="spinner"></div>
        </div>
      </div>
      <router-view />
    </main>
    </div>
    <div v-else>
      <Login></Login>
    </div>
  </v-app>
</template>
<script>
import Sidenav from "@/components/Sidenav";
import Navbar from "@/components/Navbars/Navbar.vue";
import { mapMutations, mapState } from "vuex";
import Login from "@/views/Seguridad/Login.vue";
import Swal from "sweetalert2";


export default {
  name: "App",
  components: {
    Sidenav,
    Navbar,
    Login
  },
  computed: {
    ...mapState([
      "isRTL",
      "color",
      "isAbsolute",
      "isNavFixed",
      "navbarFixed",
      "absolute",
      "showSidenav",
      "showNavbar",
      "showFooter",
      "showConfig",
      "hideConfigButton",
      "isAuth",
      "Cargando"
    ]),
    isAutenticated() {
      return this.isAuth && this.$route.name !== "Login";
    }
  },
  created() {
    this.$store.state.Cargando = false;
    
    // Solo inicializar el estado, sin redirecciones automáticas
    this.$nextTick(() => {
      this.initializeAuthenticationState();
    });
    this.initializeSidenav();
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    
    initializeAuthenticationState() {
      const authData = this.getAuthData();
      
      if (authData && this.isValidAuthData(authData)) {
        // Valid authentication data found - solo restaurar estado
        this.$store.state.isAuth = true;
        this.restoreUserDataFromToken(authData.token);
        this.setupAutoLogout(authData.expiresAt);
        this.setupMultiTabLogout();
      } else {
        // No valid authentication data - limpiar estado
        this.clearAuthenticationState();
      }
    },
    
    getAuthData() {
      try {
        // Primero intentar localStorage (persiste entre actualizaciones)
        let authDataStr = localStorage.getItem("authData");
        
        // Si no está en localStorage, intentar sessionStorage
        if (!authDataStr) {
          authDataStr = sessionStorage.getItem("authData");
        }
        
        if (authDataStr) {
          const authData = JSON.parse(authDataStr);
          return authData;
        }
        
        // Fallback to old token storage for backward compatibility
        const oldToken = sessionStorage.getItem("token") || localStorage.getItem("token");
        
        if (oldToken) {
          return { token: oldToken, expiresAt: null };
        }
        
        return null;
      } catch (error) {
        console.error("Error getting auth data:", error);
        return null;
      }
    },
    
    isValidAuthData(authData) {
      if (!authData || !authData.token) {
        return false;
      }
      
      // Check if token has expired (8 hours limit) - usar nuestro sistema de expiración
      if (authData.expiresAt && Date.now() > authData.expiresAt) {
        return false;
      }
      
      // Validar que el token tenga la estructura correcta
      return this.isValidToken(authData.token);
    },
    
    restoreUserDataFromToken(token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        // Restore basic user info from token payload if available
        if (payload.user_id) {
          this.$store.state.userid = payload.user_id;
        }
        if (payload.username) {
          this.$store.state.username = payload.username;
        }
        if (payload.email) {
          this.$store.state.email = payload.email;
        }
        // Additional user data should be fetched from API if needed
      } catch (error) {
        console.warn('Could not restore user data from token:', error);
      }
    },
    
    isValidToken(token) {
      try {
        // Basic token validation
        const payload = JSON.parse(atob(token.split('.')[1]));
        
        // Check if token has required user information
        if (!payload.user_id && !payload.username) {
          return false;
        }
        
        // If token has expiration field, check if it's not expired
        if (payload.exp) {
          const currentTime = Date.now() / 1000;
          return payload.exp > currentTime;
        }
        
        // If no expiration field, consider token valid if it has user info
        return true;
        
      } catch (error) {
        console.error("Token validation error:", error);
        return false;
      }
    },
    
    setupAutoLogout(expiresAt) {
      if (!expiresAt) return;
      
      // Clear any existing timeout
      if (window.logoutTimer) {
        clearTimeout(window.logoutTimer);
      }
      
      const timeUntilExpiration = expiresAt - Date.now();
      
      if (timeUntilExpiration > 0) {
        window.logoutTimer = setTimeout(() => {
          this.performSecurityLogout('Sesión expirada después de 8 horas');
        }, timeUntilExpiration);
      }
    },
    
    setupMultiTabLogout() {
      // Listen for storage events to sync logout across tabs
      window.addEventListener('storage', (event) => {
        if (event.key === 'authData' && !event.newValue) {
          // Auth data was removed in another tab, logout this tab too
          this.performSecurityLogout('Sesión cerrada en otra pestaña');
        }
      });
      
      // Listen for beforeunload to detect browser close
      window.addEventListener('beforeunload', () => {
        // Clear session data when browser closes
        sessionStorage.removeItem("authData");
      });
    },
    
    clearAuthenticationState() {
      // Limpiar todos los datos de autenticación de ambos storages
      sessionStorage.removeItem("authData");
      sessionStorage.removeItem("token");
      localStorage.removeItem("authData");
      localStorage.removeItem("token");
      localStorage.removeItem("isAuth");
      localStorage.removeItem("username");
      localStorage.removeItem("email");
      localStorage.removeItem("userid");
      localStorage.removeItem("firstName");
      localStorage.removeItem("lastName");
      localStorage.removeItem("userSucursal");
      
      // Limpiar estado del store
      this.$store.state.isAuth = false;
      this.$store.state.username = null;
      this.$store.state.firstName = null;
      this.$store.state.lastName = null;
      this.$store.state.jwt = "";
      this.$store.state.isAdmin = false;
    },
    
    performSecurityLogout(reason) {
      // Clear all authentication data
      sessionStorage.removeItem("authData");
      sessionStorage.removeItem("token");
      $cookies.remove("token");
      
      // Clear store state
      this.$store.state.isAuth = false;
      this.$store.state.userid = null;
      this.$store.state.userSucursal = null;
      this.$store.state.username = null;
      this.$store.state.email = null;
      this.$store.state.firstName = null;
      this.$store.state.lastName = null;
      this.$store.state.rol = null;
      
      // Clear timeout
      if (window.logoutTimer) {
        clearTimeout(window.logoutTimer);
        window.logoutTimer = null;
      }
      
      // Notify user and redirect
      Swal.fire({
        icon: "warning",
        title: "Sesión Cerrada",
        text: reason,
        allowOutsideClick: false
      }).then(() => {
        this.$router.push("/");
      });
    },
    
    clearAuthenticationState() {
      this.$store.state.isAuth = false;
      this.$store.state.userid = null;
      this.$store.state.userSucursal = null;
      this.$store.state.username = null;
      this.$store.state.email = null;
      this.$store.state.firstName = null;
      this.$store.state.lastName = null;
      this.$store.state.rol = null;
      sessionStorage.removeItem("authData");
      sessionStorage.removeItem("token");
      $cookies.remove("token");
      
      // Clear timeout
      if (window.logoutTimer) {
        clearTimeout(window.logoutTimer);
        window.logoutTimer = null;
      }
    },
    
    initializeSidenav() {
      const sidenav = document.getElementsByClassName("g-sidenav-show")[0];
      if (sidenav && window.innerWidth > 1200) {
        sidenav.classList.add("g-sidenav-pinned");
      }
    },
    
    onTransitionEnd(event) {
      if (event.propertyName === "opacity" && !this.showUser) {
        this.$emit("close");
      }
    }
  }
};
</script>
<style lang="scss">
@import '~@/assets/scss/variables';

.modal_cargando {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99999999;
  height: 100%;
  background-color: $color-primary;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.modal_cargando.show {
  opacity: 1;
}

.modal-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.modal-content {
  background-color: $color-background;
  padding: 20px;
  border-radius: 15px;
  width: 50%;
}

.spinner {
  width: 80px;
  height: 80px;
  border: 6px solid $color-background; /* Color del borde superior */
  border-top: 6px solid $color-secondary; /* Color del borde */
  border-radius: 50%;
  animation: spin 2s linear infinite; /* Duración de la animación */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
